<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  {{ data.message }}
</div>
<div mat-dialog-actions>
  <app-button-multicolor [buttons]="buttons" (navigate)="navigate($event)"></app-button-multicolor>
</div>
